import { isUpdateBasketItemErrorResponse, Name as ErrorEventName } from '@ori-events/update-basket-item-failed';
import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function updateBasketItemHandler({
  detail: {
    lineNumber,
    placement,
    quantity
  }
}) {
  const response = await fetch(`${RequestUrl.UpdateBasketItem}?lineNumber=${lineNumber}&quantity=${quantity}`, getHttpRequestSettings({
    placement
  }));
  const data = convertToCamelCase(await response.json());
  if (isUpdateBasketItemErrorResponse(data)) {
    const errorEvent = new CustomEvent(ErrorEventName, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
//# sourceMappingURL=updateBasketItemHandler.js.map